import React, { useEffect, useState } from 'react';
import { IonRow, IonCol, IonContent, IonPage, IonImg, IonText } from '@ionic/react';
import './PaymentSuccess.scss';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../store';
import * as locationStore from '../store/LocationStore';
import { baseUrl, cacheBust } from '../helpers/configHelper';

interface ICounterItem {
    menuItemId: number;
    menuItemName: string;
    sku: string;
    quantity: number;
}

interface ICounterItems {
    number: number;
    menuItems: ICounterItem[];
}

const PaymentSuccess: React.FC = () => {
    const orderNumber = useSelector((state: ApplicationState) => state.basket?.orderNumber);
    const basketState = useSelector((state: ApplicationState) => state.basket);
    const locationState = useSelector((state: ApplicationState) => state.location);

    const [counterItems, setCounterItems] = useState<ICounterItems>({ number: 0, menuItems: [] });
    const [isKitchenItemPresent, setIsKitchenItemPresent] = useState(false);

    useEffect(() => {
        if (basketState?.tmpBasket) {
            let _counterItems: ICounterItem[] = [];

            basketState.tmpBasket.menuItems.forEach((item: IMopMenuItemDetail) => {
                if (!item.isDealItem) {
                    if (!item.isKitchenItem || (item.itemTags && item.itemTags.toLowerCase().includes('[cc]'))) {
                        const counterItem: ICounterItem = {
                            menuItemId: item.menuItemId,
                            menuItemName: item.menuItemName,
                            sku: item.sku,
                            quantity: item.quantity,
                        }

                        _counterItems.push(counterItem);
                    }
                } else {
                    item.modifierGroups
                        .filter((group: IMopModifierGroup) => group.selected === true)
                        .forEach((group: IMopModifierGroup) => {
                            group.modifierGroupItems
                                .filter((item: IMopModifierGroupItem) => item.quantitySelected > 0)
                                .forEach((item: IMopModifierGroupItem) => {
                                    if (!item.isKitchenItem || (item.productFlags && item.productFlags.includes('[cc]'))) {
                                        const counterItem: ICounterItem = {
                                            menuItemId: item.menuItemId,
                                            menuItemName: item.menuItemName,
                                            sku: item.sku,
                                            quantity: item.quantitySelected,
                                        }

                                        _counterItems.push(counterItem);
                                    }
                                })
                        })
                }
            });

            setCounterItems({
                number: _counterItems.length,
                menuItems: _counterItems,
            });

            let _isKitchenItemsPresent = basketState.tmpBasket.menuItems.some((item) => (
                item.isKitchenItem === true
            ));

            setIsKitchenItemPresent(_isKitchenItemsPresent);
        }
        console.log(orderNumber);
    }, [basketState?.tmpBasket]);

    return (
        <IonPage>
            <IonContent fullscreen>
                <div className="paymentSuccessWrapper">
                    <div className="paymentSuccessOrderInfoWrapper">
                        <div className="paymentSuccessOrderInfo">
                            <IonImg className="paymentSuccessHeaderImage" src={`${baseUrl()}/images/assets/green_tick.png`} />
                            <div className="paymentSuccessTitle">We've got your order!</div>
                            {
                                (counterItems.menuItems.length > 0 && locationState?.selectedChannel?.channelType == locationStore.simpleChannelType.TableOrder)
                                    ?
                                    <>
                                        <div className="paymentSuccessTitleBold">Don't forget</div>
                                        <div className="paymentSuccessTitleSmall"><strong>Collect {counterItems.number} {counterItems.menuItems.length > 1 ? "items" : "item"}</strong> from the <strong>counter</strong></div>
                                        <ul className="paymentSuccessCounterItemsList">
                                            {
                                                counterItems.menuItems.map((item) => {
                                                    return(
                                                        <li key={`counterItem_${item.sku}`} className='paymentSuccessCounterItem'>
                                                            <IonRow key={item.menuItemId} className="menuItemRow">

                                                                <IonCol size="3" className="MenuItemImageWrapper" >
                                                                    <IonImg onIonError={(e) => { console.log(e) }} className="MenuItemImage" src={(`${baseUrl()}/images/ProductShots/${item.sku}_PLP.png`) + `?v=${cacheBust()}`} />
                                                                </IonCol>
                                                                <IonCol className="MenuItemTitleWrapper">
                                                                    <IonText className="MenuItemTitle" >
                                                                        <span dangerouslySetInnerHTML={{ __html: item.menuItemName ? item.menuItemName : '' }}></span>
                                                                    </IonText>
                                                                </IonCol>
                                                            </IonRow>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </>
                                    :
                                    <>
                                        <div className="paymentSuccessTitleSmall">Your order reference</div>
                                        <div className="paymentSuccessOrderData" dangerouslySetInnerHTML={{ __html: orderNumber as string }}></div>
                                    </>
                            }
                            {
                                locationState?.selectedChannel?.channelType == locationStore.simpleChannelType.TableOrder
                                    ?
                                    <>
                                        {
                                            basketState?.tableNumber &&
                                            <>
                                                <div className="paymentSuccessTitleSmall">{counterItems.menuItems.length > 0 ? "We'll bring the rest of your order to:" : "We'll bring your order to:"}</div>
                                                <div className="paymentSuccessOrderData" dangerouslySetInnerHTML={{ __html: 'Table ' + basketState.tableNumber.toString() }}></div>
                                                {
                                                    counterItems.menuItems.length > 0 &&
                                                    <>
                                                        <div className="paymentSuccessTitleSmall">Your order reference: <strong>{orderNumber}</strong></div>
                                                    </>
                                                }
                                            </>
                                        }
                                    </>
                                    :
                                    <>
                                        {
                                            locationState?.selectedTimeSlot.label == "ASAP" &&
                                                <>
                                                    <div className="paymentSuccessTitleSmall">Your order is being prepared and will be ready for you to collect shortly</div>
                                                </>
                                        }
                                    </>
                            }
                            {
                                locationState?.selectedTimeSlot.label !== "ASAP" &&
                                    <>
                                        {
                                            locationState?.selectedTimeSlot.startTime &&
                                            <>
                                                <div className="paymentSuccessTitleSmall">Your order is being prepared for</div>
                                                <div className="paymentSuccessOrderData" dangerouslySetInnerHTML={{ __html: locationState.selectedTimeSlot.startTime }}></div>
                                            </>
                                        }
                                    </>
                            }
                        </div>
                    </div>
                    {
                        locationState?.selectedChannel?.channelType == locationStore.simpleChannelType.TableOrder
                            ?
                            <>
                                <div className="paymentSuccessInstructions">
                                    We'll deliver your order as soon as it's ready.<br />
                                    A receipt has been sent to your email.
                                </div>
                            </>
                            :
                            <>
                                {
                                    locationState?.selectedTimeSlot.label == "ASAP" ?
                                        <>
                                            <div className="paymentSuccessInstructions">
                                                Please head over to the collection point in store.<br />
                                                A receipt has been sent to your email.
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className="paymentSuccessInstructions">
                                                We'll let you know when it's ready to collect.<br />
                                                A receipt has been sent to your email.
                                            </div>
                                        </>
                                }
                            </>
                    }
                </div>
            </IonContent>
        </IonPage>
    );
};

export default PaymentSuccess;
